// extracted by mini-css-extract-plugin
module.exports = {"middleBar":"MiddleBar_middleBar__33yxr","middleBarMain":"MiddleBar_middleBarMain__2dOiJ","middleBarMainWrapper":"MiddleBar_middleBarMainWrapper__MPO36"};